import React from 'react';

// size is viewBox units; rendered size lives in ChecklistPreview.scss.
const ProgressRing = ({ done, total, size, strokeWidth, label, className }) => {
	const radius = (size - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;
	const progress = total ? done / total : 0;
	const circle = { cx: size / 2, cy: size / 2, r: radius, fill: 'none', strokeWidth };

	return (
		<div
			className={`cl-ring ${className}`}
			role="progressbar"
			aria-valuemin={0}
			aria-valuemax={total}
			aria-valuenow={done}
		>
			<svg viewBox={`0 0 ${size} ${size}`} className="cl-ring-svg">
				<circle {...circle} className="cl-ring-track" />
				{/* A round cap draws a dot even at zero length, so an empty ring leaves the fill out. */}
				{done > 0 && (
					<circle
						{...circle}
						className="cl-ring-fill"
						strokeLinecap="round"
						strokeDasharray={circumference}
						strokeDashoffset={circumference * (1 - progress)}
					/>
				)}
			</svg>
			{label && <span className="cl-ring-label">{label}</span>}
		</div>
	);
};

export default ProgressRing;
